import React from 'react';
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar.js";
import './CommonContainerStyles.css';
import Tabs from "../../Components/Tabs/Tabs"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import UserAvatar from "../../Components/UserAvatar/UserAvatar2";
import StickyButton from "../../Components/Buttons/StickyButton.js";

function TeacherInformationContainer(props) {
  const { header, tabs, handleSubmit } = props;
  return (
    <div className="page-container-outer">
      <div className="menu-logo-bar">
        <SwitchMenuBar isViewAsTeacher={true} isTeacherInfo={true} />
      </div>
      <div className="page-container-main bg-photoregister">
        <div className="bg-gradient page-container-bg"></div>
        <div className="page-container-header">
          <div className="page-container-header-inner">
            <UserAvatar />
            <h1>{header}</h1>
          </div>
        </div>
        <div className="page-container-inner">
          {tabs ? <Tabs tabs={tabs} /> : null}
          <form>
            <div className="container px-0">
              {props.children}
            </div>
          </form>
          <ConfirmButton disabled={props.disabled} type="submit" onClick={handleSubmit}>
            Submit
          </ConfirmButton>
        </div>
      </div>
      {/* <StickyButton/> */}
    </div>
  )
}

export default TeacherInformationContainer;